var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GaodeServiceStatus } from '../enums';
import { ImplEnum, LbsCodeEnum, LBSRequestErrorType } from '../enums/lbs';
import { isArray, isBoolean, isEmptyArray, isObject, isString } from './is';
/**
 * 将高德返回值转换为LBS格式返回值
 * @param response
 * @param data
 */
export function transformAMapBasicResponse(response, data) {
    return {
        code: "".concat(response.status) === GaodeServiceStatus.success
            ? LbsCodeEnum.SUCCESS
            : LbsCodeEnum.SERVICE_ERROR,
        data: {
            // count 没有实际作用。`count: 0`是为了与lbs服务端返回保持一致
            count: 0,
            status: +response.status,
            infoCode: +response.infocode,
            info: response.info,
            impl: ImplEnum.GAODE_FRONT_END,
            data: data,
        },
    };
}
/**
 * 将V4版本高德返回值转换为LBS格式返回值
 * @param response
 * @param data
 */
export function V4TransformAMapBasicResponse(response, data) {
    var errcode = +response.errcode;
    var code = "".concat(response.errcode) === '0'
        ? LbsCodeEnum.SUCCESS
        : LbsCodeEnum.SERVICE_ERROR;
    var status = errcode === 0 ? 1 : 0;
    var infoCode = errcode === 0 ? LBSRequestErrorType.OK : errcode;
    var info = response.errdetail || response.errmsg;
    return {
        code: code,
        data: {
            // count 没有实际作用。`count: 0`是为了与lbs服务端返回保持一致
            count: 0,
            status: status,
            infoCode: infoCode,
            info: info,
            impl: ImplEnum.GAODE_FRONT_END,
            data: data,
        },
    };
}
/**
 * 高德返回值转换函数
 * @param val
 * @param keys
 */
export function transformAMapEmptyArrayToString(val, keys) {
    return keys.reduce(function (pre, cur) {
        var _a;
        var v = val[cur];
        return __assign(__assign({}, pre), (_a = {}, _a[cur] = transformEmptyArrayToString(v), _a));
    }, {});
}
/**
 * 高德返回值 字符串类型数据，却返回了非字符串类型数据，例如`[]`
 * 返回值必须是`string`，将`[]`转换为`""`
 * @param v
 */
export function transformEmptyArrayToString(v) {
    if (typeof v === 'string')
        return v;
    else if (isEmptyArray(v))
        return '';
    return v;
}
/**
 * 删除对象中的`undefined`或`null`
 * @param obj
 */
export function removeEmpty(obj) {
    if (isObject(obj)) {
        return Object.keys(obj).reduce(function (acc, key) {
            var _a;
            return (obj[key] == null ? acc : __assign(__assign({}, acc), (_a = {}, _a[key] = obj[key], _a)));
        }, {});
    }
    return {};
}
/**
 * 删除对象中的空`''`字符串
 * @param obj
 */
export function removeEmptyString(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
        var _a;
        return (obj[key] === '' ? acc : __assign(__assign({}, acc), (_a = {}, _a[key] = obj[key], _a)));
    }, {});
}
/**
 * 转换不同格式的`headers`请求返回
 * @param headers
 */
export function convertHeaders(headers) {
    if (isObject(headers))
        return headers;
    if (isArray(headers)) {
        var firstHeader = headers[0];
        if (isObject(firstHeader)) {
            var _headers = headers.filter(function (v) { return isObject(v); });
            return Object.assign.apply(Object, __spreadArray([{}], _headers, false));
        }
    }
    return headers;
}
/**
 * ```
 * 120.223456,35.432356 => { lng: 120.223456, lat: 35.432356 }
 * ```
 */
export function convertPoint(point) {
    if (isString(point)) {
        var _a = point.split(','), lng = _a[0], lat = _a[1];
        return { lng: +lng, lat: +lat };
    }
    return undefined;
}
/**
 * ```
 * { lng: 120.223456, lat: 35.432356 } => 120.223456,35.432356
 * ```
 */
export function convertPointString(points) {
    if (isObject(points)) {
        var lng = points.lng, lat = points.lat;
        return "".concat(lng, ",").concat(lat);
    }
    return '';
}
/**
 * ```
 * [
 *  { lng: 120.223456, lat: 35.432356 },
 *  { lng: 120.223457, lat: 35.432359 }
 * ]
 * =>
 * 120.223456,35.432356|120.223457,35.432359
 * ```
 */
export function convertPointsString(points, split) {
    if (split === void 0) { split = '|'; }
    if (isArray(points)) {
        return points.map(function (v) { return convertPointString(v); }).join(split);
    }
    return '';
}
/**
 * ```
 * ['商场', '衣服'] => 商场|衣服
 * ```
 */
export function convertKeywords(keywords) {
    if (isArray(keywords))
        return keywords.join('|');
    if (isString(keywords))
        return keywords;
    return '';
}
/**
 * ```
 * false => "false"
 * "false" => "false"
 * ```
 */
export function convertBooleanToString(val) {
    if (isBoolean(val))
        return String(val);
    if (val === 'true' || val === 'false')
        return val;
    return '';
}
//# sourceMappingURL=data:application/json;base64,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